<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("add") }} {{ $tc("Aspect", 1) }} {{ $tc("Ratio", 1) }}
      </div>
      <router-link class="btn-blue" to="aspect-ratios"
        >{{ $tc("Aspect", 1) }} {{ $tc("Ratio", 1) }}
        {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in AspectRatios"
          :key="index"
          v-if="item.fieldname !== 'aspect_ratio_id'"
          class="col-lg-6 col-xl-3 align-self-center"
        >
          <div v-if="item.fieldname !== 'aspect_ratio_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  v-b-tooltip.hover.top="$t(item.tooltip)"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <!-- <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span> -->
              <span v-if="submitted && errors.has(item.fieldname)">
                {{ $tc(item.errormsg) }}</span
              >
            </p>
          </div>
          <div v-if="item.fieldname === 'aspect_ratio_is_active'">
            <div class="row">
              <div class="col-md-3 col-xl-2 align-self-center">
                <label class="mb-0">{{ $t("active") }}</label>
              </div>
              <div class="col-md-9 col-xl-10 align-self-center">
                <!-- <label class="ios-switch"> -->
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox"
                  v-model="item.fieldvalue"
                />
                <!-- <span class="switch-slider"></span>
                </label> -->
              </div>
            </div>
            <p class="error_message"></p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="handleSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="aspect-ratios"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AspectRatios from "@/helper/formJSONMaster/AspectRatio";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      AspectRatios: AspectRatios.ms_aspect_ratios,
      // v-validate="'required|email'"
      submitted: false,
      Methods: AspectRatios.Methods,
    };
  },
  mounted() {
    this.resetHandler();
  },
  methods: {
    onFocusHandler: function () {},
    resetHandler: function () {
      this.AspectRatios.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    handleSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;
          let body = this.getRequestBody(
            "POST",
            this.AspectRatios,
            this.Methods
          );
          console.log("body AspectRatios :", body);

          if (body.payload) {
            body.payload = {
              ...body.payload,
              aspect_ratio_is_active: body.payload.aspect_ratio_is_active
                ? "Y"
                : "N",
            };
          }

          MasterService.AddAspectRatio(body.payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                console.log("here :", data);
                if (flag) {
                  this.$router.push({
                    path: "aspect-ratios",
                  });
                } else {
                  this.resetHandler();
                }
              } else {
                this.$toasted.show(data.message);
                console.log("show error1 :", data.message);
              }
            })
            .catch((error) => {
              this.$toasted.show(error);
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/AspectRatiosComponent/AddAspectRatio.vue